import axios from "axios";
import firebase from "config/firebase";
import { toast } from "react-toastify";
import { RepositoryFactory } from "repository/RepositoryFactory";

export const getFans = ({ school, lastDocument, prevData }) => {
  return async (dispatch) => {
    try {
      dispatch({
        type:
          lastDocument === null
            ? "SET_FANS_ATHLETES_LOADER"
            : "SET_FANS_ATHLETES_LOADMORELOADER",
        payload: true,
      });

      let query = firebase
        .firestore()
        .collection("users")
        .where("role", "==", "fan")
        .where("school", "array-contains", school)
        .limit(5);

      if (lastDocument) {
        query = query.startAfter(lastDocument);
      }

      const querySnapshot = await query.get();
      const data = prevData || [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });

      console.log("data: ", data);
      const payload = {
        data,
        hasMoreDocuments: querySnapshot.docs.length === 5,
        lastDocument:
          querySnapshot.docs.length > 0
            ? querySnapshot.docs[querySnapshot.docs.length - 1]
            : null,
      };

      dispatch({ type: "SET_SCHOOL_FANS", payload });
      dispatch({
        type:
          lastDocument === null
            ? "SET_FANS_ATHLETES_LOADER"
            : "SET_FANS_ATHLETES_LOADMORELOADER",
        payload: false,
      });
    } catch (error) {
      console.error("Error fetching fans/athletes", error);
      dispatch({
        type:
          lastDocument === null
            ? "SET_FANS_ATHLETES_LOADER"
            : "SET_FANS_ATHLETES_LOADMORELOADER",
        payload: false,
      });
    }
  };
};

export const getAthletes = ({
  state,
  city,
  school,
  lastDocument,
  prevData,
}) => {
  return async (dispatch) => {
    try {
      dispatch({
        type:
          lastDocument === null
            ? "SET_FANS_ATHLETES_LOADER"
            : "SET_FANS_ATHLETES_LOADMORELOADER",
        payload: true,
      });

      let query = firebase
        .firestore()
        .collection("users")
        .where("role", "==", "athlete")
        .where("state", "==", state)
        .where("city", "==", city)
        .where("institute_name", "==", school)
        .limit(5);

      if (lastDocument) {
        query = query.startAfter(lastDocument);
      }

      const querySnapshot = await query.get();
      const data = prevData || [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });

      const payload = {
        data,
        hasMoreDocuments: querySnapshot.docs.length === 5,
        lastDocument:
          querySnapshot.docs.length > 0
            ? querySnapshot.docs[querySnapshot.docs.length - 1]
            : null,
      };

      dispatch({ type: "SET_SCHOOL_ATHLETES", payload });

      dispatch({
        type:
          lastDocument === null
            ? "SET_FANS_ATHLETES_LOADER"
            : "SET_FANS_ATHLETES_LOADMORELOADER",
        payload: false,
      });
    } catch (error) {
      console.error("Error fetching fans/athletes", error);
      dispatch({
        type:
          lastDocument === null
            ? "SET_FANS_ATHLETES_LOADER"
            : "SET_FANS_ATHLETES_LOADMORELOADER",
        payload: false,
      });
    }
  };
};

export const searchFansOrAthletes = (
  { id, role, state, city, school },
  onSuccess
) => {
  console.log("id, role, state, city, school: ", id, role, state, city, school);
  return async (dispatch) => {
    try {
      dispatch({ type: "SET_SEARCH_LOADER", payload: true });

      let query = firebase
        .firestore()
        .collection("users")
        .where("role", "==", role)
        .where("state", "==", state)
        .where("city", "==", city);

      if (role === "fan") {
        query = query
          .where("fanID", "==", id)
          .where("school", "array-contains", school);
      } else if (role === "athlete") {
        query = query
          .where("athleteID", "==", id)
          .where("institute_name", "==", school);
      }

      const querySnapshot = await query.get();
      const data = [];

      if (querySnapshot.empty) {
        toast.info("No record found");
      } else {
        querySnapshot.forEach((doc) => {
          data.push({ id: doc.id, ...doc.data() });
        });
      }
      dispatch({ type: "SET_SEARCH_LOADER", payload: false });
      onSuccess(data);
    } catch (error) {
      console.log("Error searching fans/athletes", error);
      dispatch({ type: "SET_SEARCH_LOADER", payload: false });
    }
  };
};

export const sendFanEmail =
  (data, onComplete = () => {}) =>
  async () => {
    try {
      const sendEmail = RepositoryFactory.get("fanEmail");
      const response = await sendEmail.sendEmailFan(data);
      console.log("response=======>", response);
      if (response.data.success) {
        onComplete("success");
        toast.success("Send Email Successfully");
      } else {
        onComplete("error");
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
      onComplete();
    }
  };

export const getSportContest =
  (onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("contest")
      .where("contestType", "==", "Sport Contest")
      .get()
      .then(async (query) => {
        let data = [];
        for await (let doc of query.docs) {
          data.push({ id: doc.id, ...doc.data() });
        }
        dispatch({
          type: "GET_SPORT_CONTEST_DATA",
          payload: data,
        });
        onComplete();
      });
  };

export const suggestAthlete =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      let rejectedUsers = [];
      await Promise.all(
        data.athleteData.map(async (item) =>
          firebase
            .firestore()
            .collection("users")
            .where("athleteID", "==", item.athleteId)
            .get()
            .then(async (query) => {
              if (query.empty) {
                rejectedUsers.push(item);
              } else {
                let newData = {
                  athlete_id: item.athleteId,
                  created_at: data.created_at,
                  coach_id: data.coachId,
                  coach_name: data.coach_data.name,
                };
                await firebase
                  .firestore()
                  .collection("contest")
                  .doc(data.collectionId)
                  .collection("athlete-suggestions")
                  .add(newData);
                // let { city, institute_name, state } = query.docs[0].data();
                // if (
                //   data.coach_data.county == city &&
                //   data.coach_data.instituteName == institute_name &&
                //   data.coach_data.state == state
                // ) {} else {
                //   rejectedUsers.push(item);
                // }
              }
            })
        )
      );
      dispatch({
        type: "REJECTED_SUGGESTED_USERS",
        payload: rejectedUsers,
      });
      onComplete("success");
    } catch (error) {
      console.error(error.message);
      toast.error(error.message);
      onComplete();
    }
  };

export const getSuggestAthleteById =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("contest")
      .doc(data.collectionId)
      .collection("athlete-suggestions")
      .where("coach_id", "==", data.uid)
      .get()
      .then(async (query) => {
        if (query.empty) {
          onComplete("empty");
        } else {
          let data = [];
          for await (let doc of query.docs) {
            data.push({ id: doc.id, ...doc.data() });
          }
          dispatch({
            type: "GET_SUGGESTED_ATHLETES",
            payload: data,
          });
          onComplete("data");
        }
      });
  };
